import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICampaign } from "../../types/campaign";

export interface CampaignState {
    loading: boolean;
    loadingError: string;
    campaignTemplates: ICampaign[];
    campaigns: ICampaign[];
    campaignsLoading: boolean;
    campaignsLoadingError: string;
}

const initialState: CampaignState = {
    loading: false,
    loadingError: "",
    campaignTemplates: [],
    campaigns: [],
    campaignsLoading: false,
    campaignsLoadingError: ""
};

const campaignSlice = createSlice({
    name: "campaign",
    initialState,
    reducers: {
        setCampaignLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setCampaignLoadingError: (state, action: PayloadAction<string>) => {
            state.loadingError = action.payload;
        },
        populateCampaignTemplates: (state, action: PayloadAction<ICampaign[]>) => {
            state.campaignTemplates = [...action.payload];
        },
        addCampaignTemplate: (state, action: PayloadAction<ICampaign>) => {
            state.campaignTemplates.push(action.payload);
        },
        setCampaignsLoading: (state, action: PayloadAction<boolean>) => {
            state.campaignsLoading = action.payload;
        },
        setCampaignsLoadingError: (state, action: PayloadAction<string>) => {
            state.campaignsLoadingError = action.payload;
        },
        populateCampaigns: (state, action: PayloadAction<ICampaign[]>) => {
            state.campaigns = [...action.payload];
        },
        clearCampaigns: (state) => {
            state.campaigns = [];
        }
    }
});

export const selectCampaignTemplates = (state: { campaign: CampaignState }) =>
    state.campaign.campaignTemplates;

export const selectCampaigns = (state: { campaign: CampaignState }) => state.campaign.campaigns;

export const selectCampaignsLoading = (state: { campaign: CampaignState }) =>
    state.campaign.campaignsLoading;

// Export actions
export const {
    setCampaignLoading,
    setCampaignLoadingError,
    populateCampaignTemplates,
    addCampaignTemplate,
    setCampaignsLoading,
    setCampaignsLoadingError,
    populateCampaigns,
    clearCampaigns
} = campaignSlice.actions;

export default campaignSlice.reducer;
